import { CropPriceIndexService } from '@/services/admin/CropPriceIndexService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

export const namespaced = true

export const allowedFilters = []

export const state = {
  cropPriceIndices: null,
  cropPriceIndex: {},
  meta: null
}

export const mutations = {
  SET_CROP_PRICE_INDICES(state, cropPriceIndices) {
    state.cropPriceIndices = cropPriceIndices.data
    state.meta = cropPriceIndices.meta
  },
  SET_CROP_PRICE_INDEX(state, cropPriceIndex) {
    state.cropPriceIndex = cropPriceIndex
  },
  ADD_CROP_PRICE_INDEX(state, cropPriceIndex) {
    state.cropPriceIndices.push(cropPriceIndex)
  },
  DELETE_CROP_PRICE_INDEX(state, cropPriceIndexId) {
    state.cropPriceIndices = state.cropPriceIndices.filter(cropPriceIndex => {
      return cropPriceIndex.id !== cropPriceIndexId
    })
  }
}

export const actions = {
  getCropPriceIndices({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      CropPriceIndexService.getCropPriceIndices(newQuery)
        .then(response => {
          commit('SET_CROP_PRICE_INDICES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCropPriceIndex({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropPriceIndexService.getCropPriceIndex(params.cropPriceIndexId)
        .then(response => {
          commit('SET_CROP_PRICE_INDEX', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createCropPriceIndex({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropPriceIndexService.createCropPriceIndex(params)
        .then(response => {
          commit('ADD_CROP_PRICE_INDEX', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateCropPriceIndex({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropPriceIndexService.updateCropPriceIndex(params.cropPriceIndexId, params.cropPriceIndex)
        .then(response => {
          commit('SET_CROP_PRICE_INDEX', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteCropPriceIndex({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CropPriceIndexService.deleteCropPriceIndex(params.cropPriceIndexId)
        .then(response => {
          commit('DELETE_CROP_PRICE_INDEX', params.cropPriceIndexId)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
